import { useFlatData } from '@interxfi/api-client';
import { useIxcCasesV1CaseQueryServiceCaseList } from '@interxfi/api-client/generated/hooks/ixc-cases-v1-case-query-service-case-list';
import {
  type IxcCasesV1CaseQueryServiceCaseListCaseListRequest,
  IxcCasesV1CaseQueryServiceCaseListFilterableFields,
  IxcCasesV1CaseStatus,
} from '@interxfi/types';

const PAGE_SIZE = 20;

const OPEN_CASE_REQUEST: IxcCasesV1CaseQueryServiceCaseListCaseListRequest = {
  page: {
    pageSize: PAGE_SIZE.toString(),
  },
  query: {
    filters: [
      {
        field: {
          name: IxcCasesV1CaseQueryServiceCaseListFilterableFields.Status,
          type: { value: IxcCasesV1CaseStatus.Open },
        },
      },
    ],
  },
};

export function useOpenCaseCount() {
  const { data } = useIxcCasesV1CaseQueryServiceCaseList(OPEN_CASE_REQUEST);
  const { length } = useFlatData(data, 'case');

  return { count: length, pageSize: PAGE_SIZE };
}
